import { themeByCSSVariables } from '@shared/lib/theme'

export const infoBannerSizes = {
  s: 's',
  l: 'l',
}

export const infoBannerTextSizes = {
  [infoBannerSizes.s]: 'captionL',
  [infoBannerSizes.l]: 'pS',
} as const

export const infoBannerVariants = {
  orange: 'orange',
  purple: 'purple',
}

export const infoBannerIconColorsByVariant = {
  [infoBannerVariants.orange]: themeByCSSVariables.colors.icon.warning,
  [infoBannerVariants.purple]: themeByCSSVariables.colors.icon.accent,
}

export const infoBannerBackgroundColorsByVariant = {
  [infoBannerVariants.orange]: themeByCSSVariables.colors.background.warning,
  [infoBannerVariants.purple]: themeByCSSVariables.colors.background.accent_30,
}
